import React from "react";
import { Tooltip } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import {
  getPortListAndFileList,
  getNextPairInfo,
  changePort,
  // DIE,
  // PARALLEL,
  // DIE_TERMINATION,
  changeTerminationValue,
  getTargetModelFiles,
} from '../../../../../services/Andes_v2/channel/channelBuilder';
import PortSelectPopover from './PortSelectPopover'
import ModelSetupPanel from "./ModelSetupPanel";

class ModelRender extends React.Component {
  constructor() {
    super();
    this.state = {
      modelSetupParams: null, // { pairs, files, modelIndex, modelType, pairIn }
      modelSetupVisible: "",
      portList: [],
      fileList: [],
      fileValue: [],
    }
  }

  clickSignal = (pairs, modelType, modelIndex, pairIn, type, modelSetupVisible) => {
    if (!pairIn.pin) {
      return;
    }
    this.setState({
      modelSetupParams: {
        pairs,
        modelIndex,
        modelType,
        pairIn,
        type
      },
      modelSetupVisible
    }, () => {
      this.modelSetupPanelRef.setData();
    })
  }

  // --> model box and port select popover<--
  openNodePopover = (pairInfo, type, modelType, pairs, modelIndex, otherKeyStr) => {
    // set portList, fileList, 
    const { fileInfoList, components } = this.props;
    const files = getTargetModelFiles(pairInfo.comp, modelIndex, otherKeyStr, components);
    const { portList, fileList, fileValue } = getPortListAndFileList(pairInfo, null, pairs, files, fileInfoList, otherKeyStr);
    this.setState({
      portList,
      fileList,
      fileValue
    }, () => {
      this.props.setNodePopoverVisible(`${type}-${modelType}-${modelIndex}-${pairInfo.signal}-${pairInfo.net}-${pairInfo.pin}-${otherKeyStr}`)
    })
  }

  closePortPopover = () => {
    this.setState({
      portList: [],
      fileList: [],
      fileValue: ""
    }, () => {
      this.props.setNodePopoverVisible("")
    })
  }

  selectPort = (node, fileValue, pairInfo, pairs, modelType, modelIndex, pairIndex, type, otherKeyStr) => {
    const { components } = this.props;
    const { newComponents, newPairs } = changePort("add", { node, fileValue, pairInfo, modelIndex, components }, 'object', otherKeyStr);
    this.props.updateChannelComponents(newComponents, true);

    const nextPairInfo = getNextPairInfo(pairInfo, pairIndex, type, pairs, otherKeyStr);
    if (nextPairInfo) {
      this.openNodePopover(nextPairInfo, type, modelType, newPairs, modelIndex, otherKeyStr);
    } else {
      this.closePortPopover();
    }
  }

  deletePort = (e, pairInfo, modelIndex, otherKeyStr) => {
    e && e.stopPropagation();
    const { components } = this.props;
    const newComponents = changePort("delete", { pairInfo, modelIndex, components }, undefined, otherKeyStr);
    this.props.updateChannelComponents(newComponents, true);
  }

  // label: "fileName::subckt", key: "libraryId::modelKey::subckt"| "libraryId::modelKey"
  selectFile = (label = "", value, pairs) => {
    // set fileValue to state
    const { fileInfoList } = this.props;
    const [fileName] = label.split("::");
    const [libraryId, modelKey, subckt] = value.split("::");
    const selectFileInfo = {
      fileName,
      libraryId,
      modelKey,
      subckt,
    }
    const { portList, fileValue } = getPortListAndFileList(null, selectFileInfo, pairs, [], fileInfoList);
    this.setState({ fileValue, portList });
  }

  // otherKeyStr : not use
  nodeRender = (pairInfo, port, modelType = "", pairs, modelIndex, pairIndex, type, otherKeyStr) => {
    const { nodePopoverVisible } = this.props;
    const { portList, fileList, fileValue } = this.state;
    const id = `${type}-${modelType}-${modelIndex}-${pairInfo.signal}-${pairInfo.net}-${pairInfo.pin}-${otherKeyStr}`;
    return !pairInfo.pin ? null
      : <PortSelectPopover
        key={id}
        id={id}
        pairInfo={pairInfo}
        portList={portList}
        portValue={port}
        displayPin={pairInfo.displayPin}
        closePortPopover={this.closePortPopover}
        selectNode={(node) => this.selectPort(node, fileValue, pairInfo, pairs, modelType, modelIndex, pairIndex, type, otherKeyStr)}
        visible={nodePopoverVisible === id}
        fileValue={fileValue}
        fileList={fileList}
        selectFile={(label, value) => this.selectFile(label, value, pairs)}
      >
        <Tooltip
          title={pairInfo.node ? `FileName: ${pairInfo.fileName}\nPort: ${pairInfo.node}` : undefined}
          classNames={{ root: 'andes-tooltip-pre-wrap' }}
        >
          <div
            className={`port-name${(port && nodePopoverVisible !== id) ? " port-selected" : ""}`}
            onClick={(e) => { e.stopPropagation(); this.openNodePopover(pairInfo, type, modelType, pairs, modelIndex, otherKeyStr) }}
          >
            {port || "Port"}
            {port ? <CloseCircleFilled className='delete-port-icon' onClick={(e) => this.deletePort(e, pairInfo, modelIndex, otherKeyStr)} /> : null}
          </div>
        </Tooltip>
      </PortSelectPopover>
  }

  setTerminationValue = (value, pairInfo, modelIndex) => {
    const { components } = this.props;
    const newComponents = changeTerminationValue(value, pairInfo, modelIndex, components);
    this.props.updateChannelComponents(newComponents, true);
  }

  // terminationRender = (termination, pair_t, net, modelIndex, pairIndex) => {
  //   const { type, pairs } = termination;
  //   return type === SPICE
  //     ? this.nodeRender(pair_t, pair_t.node, DIE, pairs, modelIndex, pairIndex, type, DIE_TERMINATION)
  //     : <DieTerminationSVG pinT={pair_t} net={net} setTerminationValue={(value) => this.setTerminationValue(value, pair_t, modelIndex)} />
  // }

  render() {
    const { modelSetupParams, modelSetupVisible } = this.state;
    const {
      modelInfo: { pairs, modelType = "", modelIndex, termination, topology },
      type,
      designType,
      serdesType,
      signals,
      components,
      libraryStatus,
      fileInfoList,
      fileColors
    } = this.props;

    return <>
      <div className={`model-bgc-color ${modelIndex % 2 !== 1 ? " model-bgc-color-gray" : ""}`}>
        {pairs.map(({ pair_in, pair_out }, i) => {
          const pair_left = type === 'tx' ? pair_out : pair_in;
          const pair_right = type === 'tx' ? pair_in : pair_out;
          const key = `${type}-${modelType}-${pair_left.signal}-${modelIndex}-${i}`;
          const colorInfo = pair_left.node ? fileColors[`${type}-${modelIndex}-${pair_left.modelKey}`] : pair_right.node ? fileColors[`${type}-${modelIndex}-${pair_right.modelKey}`] : {};
          return <div
            className={"port-box" + (modelSetupVisible === key ? " port-box-click" : "")}
            key={key}
            onClick={() => this.clickSignal(pairs, modelType, modelIndex, pair_in, type, key)}
            style={{ backgroundColor: colorInfo.bgColor }}
          >
            {this.nodeRender(pair_left, pair_left.node, modelType, pairs, modelIndex, i, type)}
            {!pair_left.pin && !pair_right.pin ? null : <div className={"signal-name" /*+ (modelType === DIE && topology === PARALLEL ? " mg-r-8" : "")*/}>
              {pair_in.signal}
            </div>}
            {/* {modelType === DIE && topology === PARALLEL ? null : this.nodeRender(pair_right, pair_right.node, modelType, pairs, modelIndex, i, type)} */}
            {this.nodeRender(pair_right, pair_right.node, modelType, pairs, modelIndex, i, type)}
            {/* DIE - Termination */}
            {/* {modelType === DIE && topology === SERIES ? this.terminationRender(termination, pair_t, pair_in.net, modelIndex, i) : null} */}
          </div>
        })}
      </div>
      {modelSetupParams ? <ModelSetupPanel
        ref={ref => this.modelSetupPanelRef = ref}
        fileInfoList={fileInfoList}
        designType={designType}
        serdesType={serdesType}
        signals={signals}
        components={components}
        libraryStatus={libraryStatus}
        topology={topology}
        termination={termination}
        modelSetupParams={modelSetupParams}
        updateChannelComponents={this.props.updateChannelComponents}
        closePanel={() => this.setState({ modelSetupParams: null, modelSetupVisible: "" })}
      /> : null}
    </>
  }
}

export default ModelRender;